import { faBalloon } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import { StandaloneFetalSexBalloonIconSvg } from "./StandaloneFetalSexCard.styles";

const [balloonViewBoxWidth, balloonViewBoxHeight, , , balloonPath] =
  faBalloon.icon;

export const StandaloneFetalSexBalloonIcon = (): React.ReactElement => (
  <StandaloneFetalSexBalloonIconSvg
    aria-hidden="true"
    fill="none"
    viewBox="0 0 45 45"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      className="standalone-fetal-sex-balloon-circle"
      height="43"
      rx="21.5"
      stroke="currentColor"
      strokeWidth="2"
      width="43"
      x="1"
      y="1"
    />
    {/* The balloon body must span 15 of the 45 viewBox units: the pop
        animation's BALLOON_BODY_COVER_FRACTION is derived from that ratio. */}
    <svg
      className="standalone-fetal-sex-balloon-path"
      height="20"
      viewBox={`0 0 ${balloonViewBoxWidth} ${balloonViewBoxHeight}`}
      width="15"
      x="15"
      y="13"
    >
      <path d={balloonPath as string} fill="currentColor" />
    </svg>
  </StandaloneFetalSexBalloonIconSvg>
);
